import type { TranslationMessages } from './types';

export const richTextUltra: TranslationMessages = {
  tabs: {
    richText: 'Rich Text',
    html: 'HTML',
    plainText: 'Plain Text',
  },
  placeholders: {
    richText: 'Enter rich text content...',
    html: 'Enter HTML content...',
    plainText: 'Enter plain text content...',
  },
};
